// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientPodContactLensEyeResponse } from './patient-pod-contact-lens-eye-response';

// @ts-ignore
import { PersonNameResponse } from './person-name-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodContactLensResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodContactLensResponse extends GandalfModelBase {

	@GandalfProperty({ designType: PersonNameResponse })
	authorizedBy!: PersonNameResponse | null;

	@GandalfProperty({ designType: Number })
	contactLensPrescriptionId!: number | null;

	@GandalfProperty({ designType: Number })
	contactLensTrialId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	expirationDate!: Date | null;

	@GandalfConstantDecorator(constants.ContactLensPrescriptionType)
	@GandalfProperty({ designType: constants.ContactLensPrescriptionType })
	lensType!: constants.ContactLensPrescriptionType | null;

	@GandalfProperty({ designType: PatientPodContactLensEyeResponse })
	od!: PatientPodContactLensEyeResponse | null;

	@GandalfProperty({ designType: Boolean })
	odDispensed!: boolean | null;

	@GandalfProperty({ designType: PatientPodContactLensEyeResponse })
	os!: PatientPodContactLensEyeResponse | null;

	@GandalfProperty({ designType: Boolean })
	osDispensed!: boolean | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.PrescriptionCurrentStatus)
	@GandalfProperty({ designType: constants.PrescriptionCurrentStatus })
	status!: constants.PrescriptionCurrentStatus | null;

}
